
<template>
    <Menu class="menu-ele" ref="sideMenu" :active-name="activeMenu" :open-names="openMenu" theme="dark" width="auto" @on-select="changeMenu">
        <template v-for="menu in menuList">
            <Submenu v-if="menu.children && menu.children.length > 0" :name="menu.name">
                <template slot="title">
                    <i v-if="menu.iconAwesome" class="fa" :class=[menu.iconAwesome] aria-hidden="true"></i>
                    <Icon v-else :type="menu.iconIview" :size="18"></Icon>{{menu.title}}
                </template>
                <MenuItem v-for="item of menu.children" :key="item.name" :name="item.name">
                    <i v-if="item.iconAwesome" class="fa" :class=[item.iconAwesome] aria-hidden="true"></i>
                    <Icon v-else :type="item.iconIview" :size="18"></Icon>{{item.title}}
                    <span class="sub" v-if="getCount(item.name) && getCount(item.name) != '0'">{{getCount(item.name)}}</span>
                    <i v-if="item.lastIconAwesome" class="fa last-icon" :class=[item.lastIconAwesome] aria-hidden="true"></i>
                    <Icon v-else class="last-icon" :type="item.lastIconIview" :size="18"></Icon>
                </MenuItem>
            </Submenu>
            <MenuItem v-else-if="menu.children.length<=0" :name="menu.name">
                <i v-if="menu.iconAwesome" class="fa" :class=[menu.iconAwesome] aria-hidden="true"></i>
                <Icon v-else :type="menu.iconIview" :size="18"></Icon>{{menu.title}}
                <span class="sub" v-if="getCount(menu.name) && getCount(menu.name) != '0'">{{getCount(menu.name)}}</span>
                <i v-if="menu.lastIconAwesome" class="fa last-icon" :class=[menu.lastIconAwesome] aria-hidden="true"></i>
                <Icon v-else class="last-icon" :type="menu.lastIconIview" :size="18"></Icon>
            </MenuItem>
        </template>
    </Menu>
</template>
<script>
    import utils from '@/utils';
    import routeAuth from "@/staticData/routeAuthEnum";
    import routeCount from '@/staticData/routeCount';

    export default {
        name: 'sidebarMenu',
        props: {
            menuList: Array,
        },
        data() {
            return {
                //当前菜单
                activeMenu: "",
                openMenu: [],
                replaceMenuName : {
                    "land-item-edit" : "land-item-add",
                    "factory-item-edit" : "factory-item-add",
                    "warehouse-item-edit" : "warehouse-item-add",
                    "officebuilding-item-edit" : "officebuilding-item-add",
                    "land-carrier-edit" : "land-carrier-add",
                    "factory-carrier-edit" : "factory-carrier-add",
                    "warehouse-carrier-edit" : "warehouse-carrier-add",
                    "officebuilding-carrier-edit" : "officebuilding-carrier-add",
                    "enterprise-edit"   :   "enterprise-add",
                },
            }
        },
        methods: {
            //初始化菜单
            initMenuStatus: function () {
                this.activeMenu = "";   //做了下初始化以防菜单默认选中出问题

                let menu = this.$route.matched[2];

                for (let i = 0; i < this.menuList.length; i++) {
                    let menuName = this.replaceMenuName.hasOwnProperty(menu.name) ? this.replaceMenuName[menu.name] : menu.name;
                    if (this.menuList[i].name == menuName) {
                        let submenuList = this.menuList[i].children;
                        if (submenuList && submenuList.length > 0) {
                            let submenu = this.$route.matched[3];
                            for (let j = 0; j < submenuList.length; j++) {
                                if (submenuList[j].name == submenu.name) {
                                    this.activeMenu = submenu.name;
                                }
                            }
                            this.openMenu = [menuName];
                        } else {
                            this.activeMenu = menuName;
                        }
                    }
                }
                //初始化菜单
                this.$nextTick(function () {
                    this.$refs.sideMenu.updateOpened();
                    this.$refs.sideMenu.updateActiveName();
                });
            },
            //切换菜单
            changeMenu(active) {
                this.$emit('on-change', active);
            },
            //头部菜单待处理数
            getCount(routeName) {
                return this.countWaitToHeadle[routeCount[routeName].apiKey];
            },
        },
        watch: {
            $route: function () {
                this.initMenuStatus();
            },
        },
        computed: {
            //头部菜单所有待处理
            countWaitToHeadle() {
                return this.$store.state.countWaitToHeadle;
            }
        },
        mounted: function () {
            this.initMenuStatus();
        }

    };
</script>
<style lang="less" scoped>
    @import "./sidebarMenu.less";
</style>
<style lang="less">
    .menu-ele .ivu-menu-submenu-title > i{
        width: auto;
    }
</style>



// WEBPACK FOOTER //
// src/pages/layout/business/SidebarMenu.vue